<template>
  <div class="pay">

    <div class="details">
      <p>订单支付</p>

      <div class="flex">

        <div style="flex:1;display: inline-block;">
          <p>应付金额￥{{cost}}</p>
          <div style="margin-bottom:15px">
            <span> 使用支付宝,微信,网银或线下转账支付</span>
          </div>
          <div>
            <span>
              <i @click="headr(index)"
                 :class="{header:current==index}"
                 class="i"
                 v-for="(i,index) in Payment "
                 :key="index">
                <img class="img"
                     :src="i.url"
                     alt="">{{i.text}}
              </i>
            </span>
            <div class="flex">
              <div class="div"
                   style="flex:2">
                <div style="   position: relative;"
                     v-if="current==0">
                  <el-radio-group v-model="pay">
                    <el-radio :label="1"><img src="../../assets/imges/e6026498a9bf005315ebbedaa6b71a50.119bf103.jpg"
                           alt=""> </el-radio>
                    <el-radio :label="2"><img src="../../assets/imges/timg.jpg"
                           alt=""></el-radio>
                  </el-radio-group>
                  <el-button style="left:50%"
                             type="primary"
                             @click="Confirmed">付 款</el-button>

                </div>
                <div v-else>
                  <span style=" background-color: #fff1f1;display: inline-block;border-radius:0.3rem;color:#ff0000">
                    *重要提醒:转账成功后,需要您把【转账成功的截图】和【注册云上初阳的手机号码】<br>
                    一同发给捷配客服QQ:574039568,他会第一时间安排财务帮您充值到账户,您才<br>
                    能支付订单！
                  </span>
                  <div class="flex">
                    <img style="width: 15rem;height:5rem;margin-top:10px"
                         src="../../assets/imges/55.jpg"
                         alt="">
                    <ul style="flex:1">
                      <li> <span>开户行:</span> <i>民生银行深圳宝安支行</i> </li>
                      <li> <span>账号:</span> <i>626039255</i> </li>
                      <li> <span>户名:</span> <i>深圳市初阳电子网络有限公司</i> </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div style="flex:1;margin-left:10px">
                <p style="margin-bottom:20px">温馨提示:</p>
                ● 付款时间（非下单时间）交期计算方式：<br>
                (1) 18点前付款交期从当天开始计算;<br>
                (2) 18点后付款、18点30分后更新文件或确认工程问题，
                交期从次日开始计算;<br>
                (3) 周六18点后和周日付款，交期从周一开始计算
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="centerDialogVisible"
               width="30%"
               center>
      <span class="flex">
        <div style="flex:1;width:100px">
          <img style="width:200px"
               :src="url"
               alt="">
          <div style="background-color:#70f3ff;  text-align: center;font-size:1.2rem;color:#000;border-radius:3px">
            <i style="font-style: unset;"> 请使用微信扫一扫</i><br>
            {{seconds+'秒'}}
          </div>
        </div>
        <div style="flex:1">
          <img style="height:300px"
               src="../../assets/imges/weinxin-pay.png"
               alt="">
        </div>

      </span>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 监听支付
      async ListeningToThe() {
        await this.$http
          .post('OrderWebservice.asmx/FindOrderIsPay', {
            Ord_Num: this.Ord_Num
          })
          .then(res => {
            if (this.$x2js.xml2js(res.data.d).NewDataSet.ds.type == 'true') {
              this.$message.success('支付成功')
              this.$router.push({ path: '/orderManagement' })
            }
          })
          .catch(res => {
            console.log(res)
          })
      },
      // 支付计时
      seconds: 120,
      // 微信支付链接
      url: 'https://api.pwmqr.com/qrcode/create/?url=',
      // 微信支付显示
      centerDialogVisible: false,
      //   订单号
      Ord_Num: '',
      //   总价
      cost: 0,
      //   支付方式样式
      current: 0,
      //   支付方式
      pay: 1,
      Payment: [
        {
          url: require('../../assets/imges/钱(1).png'),
          text: '在线支付'
        },
        {
          url: require('../../assets/imges/卡包(1).png'),
          text: '线下支付'
        }
      ]
    }
  },
  created() {
    this.PaymentData(this.$route.params.pay)
    this.Ord_Num = this.$route.params.pay
  },
  beforeDestroy() {
    clearInterval(this.timerId)
  },
  methods: {
    Confirmed() {
      console.log(this.pay)
      if (this.pay == 1) {
        this.$http
          .post('OrderWebservice.asmx/WeChatPay', {
            Ord_Num: this.Ord_Num,
            type: this.pay
          })
          .then(res => {
            console.log(res)
            this.url += this.$x2js.xml2js(res.data.d)
            this.centerDialogVisible = true
            this.timerId = setInterval(() => {
              this.ListeningToThe()
              this.seconds--
            }, 1000)
            var timerId1 = setTimeout(() => {
              clearInterval(this.timerId)
              this.$router.push({ path: '/orderManagement' })
            }, 120 * 1000)
            //console.log( this.$x2js.xml2js(res.data.d) )
          })
          .catch(res => {
             this.$router.push({ path: '/orderManagement' })
          })
        // this.centerDialogVisible = true
      } else {
        //  支付宝接口渲染
        this.$http
          .post('OrderWebservice.asmx/WeChatPay', {
            Ord_Num: this.Ord_Num,
            type: this.pay
          })
          .then(function(res) {
            var div = document.createElement('div')
            div.innerHTML = res.data.d
            document.body.appendChild(div)
            document.forms.alipaysubmit.submit() //执行submit表单提交，让页面重定向，跳转到支付宝页面
          })
          .catch(error => {})
      }
    },
    //   金额订单等数据
    PaymentData(pay) {
      this.$axios
        .post('http://182.254.196.172:8088/WebInterface/OrderWebservice.asmx/GetOrderListUser', {
          User_Guid: window.sessionStorage.getItem('User_Guid')
        })
        .then(res => {
          if (this.$x2js.xml2js(res.data.d).NewDataSet.ds.type) {
            this.$http
              .post('OrderWebservice.asmx/PayOrderDetail', {
                Ord_Num: pay
              })
              .then(res => {
                this.cost = this.$x2js.xml2js(
                  res.data.d
                ).NewDataSet.ds[0].Ord_PriceCheck
              })
              .catch(res => {
                console.log(res)
              })
          } else {
            this_.$message.error('不是该账号的订单！！！')
          }
        })
        .catch(res => {
          console.log(res)
        })
    },
    //   支付方式显示
    headr(index) {
      this.current = index
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  background-color: #fff;
  border-top: 2px solid #007aff;
}
.pay {
  p {
    font-size: 1.5rem;
    margin-bottom: 50px;
  }
  .details {
    width: 60%;
    height: 500px;
    background-color: #dddd;
    border-radius: 0.3rem;
    margin: auto;
    padding: 10px;

    .flex {
      width: 100%;
      p {
        font-size: 1.1rem;
      }
      span {
        background-color: #ddd;
        margin-top: 20px;
        .i {
          display: inline-block;
          position: relative;
          width: 150px;
          font-style: unset;
          height: 40px;
          text-align: center;
          line-height: 40px;
          border-radius: 0.3rem;
          border: 0.1rem solid #fff;
          .img {
            position: absolute;
            left: 0;
          }
        }
      }

      .div {
        background-color: #fff;
        height: 200px;
        border: 0.1rem solid #ffffff;
        width: 60%;
        border-radius: 0.3rem;
        .flex {
          ul {
            margin-left: 20px;
            li {
              height: 20px;
              span {
                background-color: #fff;
                display: inline-block;
                text-align-last: justify;
                width: 70px;
              }
              i {
                font-style: unset;
              }
            }
          }
          img {
            border: 0.1rem solid #000;
            border-radius: 0.3rem;
          }
        }
        .el-button {
          width: 100px;
          position: absolute;
          top: 150px;
        }
        .el-radio-group {
          .el-radio {
            width: 10rem;
            position: relative;
            top: 100px;
            left: 20px;
            img {
              width: 8rem;
              height: 3rem;
              position: absolute;
              bottom: -10px;
              border: 0.1rem solid #007aff;
              border-radius: 0.3rem;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/my/pay.vue